import { getPluginOptions } from '../../utils/pluginOptions'

/**
 * 获取插件配置信息
 * @param { ppn } appId 插件名称
 * @param { string } pluginAddressNo 插件位置
 * @param { object } pluginService 插件服务信息
 * @returns
 */
export function getPluginInfo (pluginPackageName, pluginService, pluginOptions) {
  const { tenantId } = pluginOptions || {}
  console.log('getPluginInfo tenantId', tenantId)
  return getPluginOptions().fetch({
    method: 'get',
    url: '/cc-plugin/plugin_manage/getPluginInfo',
    params: {
      ppn: pluginPackageName
    },
    headers: {
      tenantId
    },
    cc_com_options: pluginOptions
  }).then((res) => {
    if (res && res.data && res.data.status === 1) {
      const { data } = res
      const { pluginUniqueId } = data
      pluginService.edit.pluginId = pluginUniqueId
      pluginService.detail.pluginId = pluginUniqueId
      pluginService.delete.pluginId = pluginUniqueId
      return {
        pluginService,
        pluginInfo: data
      }
    } else {
      throw new Error('插件未启用')
    }
  })
}

/**
 * 插件保存
 * @param {*} params
 * @returns
 */
export function pluginDispatch (data, pluginOptions) {
  const { tenantId } = pluginOptions || {}
  return getPluginOptions().fetch({
    method: 'post',
    url: '/cc-plugin/plugins/plugin-dispatch/operator/pluginMethod',
    data,
    headers: { tenantId },
    cc_com_options: pluginOptions
  })
}

export function genPluginService ({ pluginConfig, dataIdKey, pluginOptions }) {
  return {
    saveOrUpdate (id, param) {
      return pluginDispatch({
        ...pluginConfig.edit,
        param: {
          [dataIdKey]: id,
          ...param
        }
      }, pluginOptions)
    },
    getPluginData (id, param) {
      return pluginDispatch({
        ...pluginConfig.detail,
        param: {
          [dataIdKey]: id,
          ...param
        }
      }, pluginOptions)
    },
    delete (id) {
      return pluginDispatch({
        ...pluginConfig.delete,
        param: {
          [dataIdKey]: id
        }
      }, pluginOptions)
    }
  }
}
